import Vue from "vue";
import Vuex from "vuex";
import StoreContext from "./modules/StoreContext/store";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";
import Product from "./modules/Product/store";
import PrependCart from "./modules/PrependCart/store";
import CurrentCart from "./modules/CurrentCart/store";
import Delivery from "./modules/Delivery/store";
import Checkout from "./modules/Checkout/store";
import Wizard from "./modules/Wizard/store";
import CurrentUser from "./modules/CurrentUser/store";
import Payment from "./modules/Payment/store";
import CompareProducts from "./modules/CompareProducts/store"
import Simulator from "./modules/SimulatorAdvanced/store"

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    storeCode: false,
    paypalMethodName: '9.PayPal.standard'
  },

  mutations,

  actions,

  modules: {
    StoreContext,
    Delivery,
    Product,
    PrependCart,
    CurrentCart,
    Checkout,
    Wizard,
    CurrentUser,
    Payment,
    CompareProducts,
    Simulator,
  },

  getters,
});

export default store;
